import { Component } from '@angular/core';
import {BaseComponent} from "../../views/base.component";
import {EventsService} from "../../lib/EventsService";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {TranslateService} from "../../translate";
import {ChartParams} from "../../views/chart/chart.component";

import * as qs from 'qs';
import {NumberFormat} from "../../pipes/number-format";
import { BillingService2 } from "../billing.service";
import { FilterParams } from "../../models/filter_form.model";

@Component({
	selector: 'app-yandex',
	templateUrl: './conversion.component.html',
	providers: [NumberFormat]
})
export class ConversionComponent extends BaseComponent {
	addFilterParams = {
		userType: 'user',
		isBilling: true,
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated', 'dateTime'],
		dateType: 'dateTime'
	};

	chartData = new ChartParams();
	chart2Data = new ChartParams();

	constructor(
		public eventsService: EventsService,
		public service2: BillingService2,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public translate: TranslateService,
		public router: Router,
		public numberFormat: NumberFormat
	) {
		super(eventsService, service2, activatedRoute, filter, translate);

		const me = this;

		const names = [
			'tariffVisitCount',
			'tariffVisitCountUniq',
			'paymentVisitCount',
			'paymentVisitCountUniq',
			'tariffAndPaymentConversion',
			'tariffAndPaymentConversionUniq',
			'paidAndPaymentConversion',
			'paidAndPaymentConversionUniq',
			'firstManualPaidCount',
			'paidCount',
		].reduce(
			function (obj, key) {
				if (key.indexOf('Uniq') > 0) {
					const keyU = key.replace('Uniq', '');
					obj[key] = me.__a('yandex.' + keyU) + ' #Уник';
				} else {
					obj[key] = me.__a('yandex.' + key);
				}

				return obj;
			},
			{}
		);

		this.chartData.setOptions({names});

		this.chart2Data.setOptions({
			names: names,
			axis: {
				y: {
					show: true,
					max: 100,
					label: {
						text: 'Проценты',
						position: 'outer-middle'
					},
					tick: {
						format: function (y) {
							return y + ' %';
						}
					}
				}
			},
			tooltip: {
				format: {
					value: value => me.numberFormat.transform(value, '1.2-2') + ' %'
				}
			}
		})
	}

	async getData() {
		const me = this;
		const fp = me.filter.getCopyFilterParams();
		
		if (!me.isPaginationReload) {
			
			await me.getCharts(fp);
			
			// Пагинация
			if (me.filter.filterParams.period == 'summary') {
				await me.getStats(fp);
				return;
			}

			me.paginationLoader = true;

			const pagination = await me.service2.conversion.pagination(me.filter.filterParams).toPromise();
			me.pagination.fill(pagination);
			
			if (pagination) {
				me.updateLinks(
					me.service2.siteBilling.getRealFullRoute()
				);
			}

			me.paginationLoader = false;
		}

		await me.getStats(fp);

		me.isPaginationReload = false;
	}
	
	async getCharts(fp: FilterParams) {
		const me = this;
		
		// Графики
		me.chartData.showLoader();
		me.chart2Data.showLoader();
		const { charts } = await me.service2.conversion.chart(fp).toPromise();
		const data1 = [];
		const data2 = [];
		for (const row of charts) {
			const key = row[0] as string;

			if (key === 'x') {
				data1.push(row);
				data2.push(row);
			} else if (key.indexOf('Conversion') > 0) {
				data2.push(row);
			} else {
				data1.push(row);
			}
		}
		
		me.chartData.data = data1;
		me.chart2Data.data = data2;
		me.chartData.hideLoader();
		me.chart2Data.hideLoader();
	}

	async getStats(fp: FilterParams) {
		const me = this;

		me.statsLoader = true;
		const { stats } = await me.service2.conversion.stats(
			{
				...fp,
				paginationDate: me.pagination.getDate(),
			}
		).toPromise();
		me.stats = stats;

		me.statsLoader = false;
	}

	async onPageChange() {
		this.isPaginationReload = true;
		
		this.filter.filterParams.page = this.pagination.page;
		
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];

		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});
	}
	
	
	async onChartTypeChange(chartType: string) {
		// await this.getCharts({
		// 	...this.filter.filterParams,
		// 	chartType,
		// });

		this.filter.filterParams.chartType = chartType;

		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];

		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});
	}
}
